/** Addresses from flat IDX summaries, nested detail locations, or private listings. */
const clean = value => value == null ? '' : String(value).trim();
const locationOf = property => ({ ...property, ...property?.location });

export function formatStreetAddress(property = {}) {
  const location = locationOf(property);
  const street = ['street_number', 'street_dir_prefix', 'street_name', 'street_suffix', 'street_dir_suffix']
    .map(key => clean(location[key])).filter(Boolean).join(' ');
  const unit = clean(location.unit_number);
  const labeledUnit = unit && (/^(?:apt\b|apartment\b|unit\b|suite\b|ste\b|#)/i.test(unit) ? unit : `Unit ${unit}`);
  return [street, labeledUnit].filter(Boolean).join(', ');
}

export function formatPropertyAddress(property = {}, { streetOnly = false } = {}) {
  const location = locationOf(property);
  const explicit = [property.address, property.street_address, property.full_address,
    location.address, location.street_address, location.full_address].map(clean).find(Boolean);
  if (explicit) return explicit;
  const street = formatStreetAddress(property);
  if (streetOnly) return street || clean(location.city);
  const region = [location.state || location.state_province, location.postal_code].map(clean).filter(Boolean).join(' ');
  return [street, clean(location.city), region].filter(Boolean).join(', ');
}
